import { Download } from 'lucide-react';

// Audio player + download affordance. The bare <audio controls> has no download
// button in most browsers' native controls (or hides it behind a ⋮ menu), so
// Alex couldn't grab the file (2026-07-06). We add an explicit button.
//
// Cross-origin download: the storage-api URL is a different origin, where the
// HTML `download` attribute is IGNORED for security — the browser would just
// navigate/play instead. But storage-api honours `?download=1` by setting
// `Content-Disposition: attachment; filename="<original>"` server-side, which
// forces a real download WITH the original filename even cross-origin. So for
// storage-media URLs we hit that param; for other (same-origin/direct) audio
// URLs the `download` attribute is the best-effort hint.

function isStorageMedia(url: string): boolean {
  return /\/storage\/media\//.test(url);
}

function downloadHref(url: string): string {
  if (!isStorageMedia(url)) return url;
  return url + (url.includes('?') ? '&' : '?') + 'download=1';
}

export function AudioBlock({ src, className, style }: {
  src: string;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <span className="audio-block">
      <audio controls src={src} className={className ?? 'inline-media-audio'} style={style} />
      <a
        className="audio-dl"
        href={downloadHref(src)}
        download
        target="_blank"
        rel="noopener noreferrer"
        title="Audio herunterladen"
        aria-label="Audio herunterladen"
      >
        <Download size={15} />
      </a>
    </span>
  );
}
